import t from "../../../helpers/t";
import React from "react";
import Biscuit from "../../../../utils/Biscuit";

export const InvoiceProgressBar = (props) => {
  const { invoice } = props;
  return (
    <>
      <div className={"inb-contingent-progress"} style={{ marginBottom: "-1rem" }}>
        <>
          <div
            className="progress beautify"
            role="progressbar"
            tabIndex="0"
            aria-valuenow="50"
            aria-valuemin="0"
            aria-valuetext="50 percent"
            aria-valuemax="100"
          >
            <div className="progress-bars">
              {/*<span className="progress-meter" style={{width: "100%"}}> </span>*/}
            </div>
            <p className="progress-meter-text">
              {invoice.extern_invoices_positions.length +
                " " +
                (invoice.extern_invoices_positions.length === 1
                  ? t("position", null, "capital")
                  : t("positions", null, "capital"))}
            </p>
          </div>
        </>
      </div>
    </>
  );
};
